
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';


const COLORS = [
  '#b54d7ac9',                // Rich Berry (Complement to Sage Green)
  'rgba(50, 150, 170, 0.82)',  // Deep Aqua (Complement to Coral)
  '#63a346c3',                // Meadow Green (Complement to Purple)
  '#a81d32cb',                // Deep Crimson (Complement to Teal)
  '#4062a0cb',                // Soft Navy (Complement to Gold/Brown)
  '#2a7296c6',                // Slate Blue (Complement to Terra Cotta)
  '#2141b5d2',                // Electric Indigo (Complement to Yellow)
  '#6a6dbdd4',                // Dusk Violet (Complement to Beige)
  'rgba(30, 140, 160, 0.85)'   // Steel Teal (Complement to Red-Orange)
];
const PieMembers = ({ data }) => {

  // 1. Use reduce() to count the occurrences in an object
  const countsObject = data.reduce((accumulator, currentItem) => {
    const category = currentItem.type;
    if (!accumulator[category]) {
      accumulator[category] = {
        name: category,
        value: 0
      };
    }
    if (accumulator[category]) {
      accumulator[category].value = accumulator[category].value + 1;
    }
    return accumulator;
  }, {}); // Start with an empty object as the accumulator

  // 2. Convert the object of counts into an array
  const newArray = Object.values(countsObject);


  return (
    <>
      <ResponsiveContainer width="100%" height={400} className="rounded">
        <PieChart>
          <Pie
            data={newArray}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ percent }) => ` ${(percent * 100).toFixed(0)}%`}
            outerRadius={150}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip contentStyle={{ backgroundColor: '#4646e8', border: '1px solid #333', borderRadius: '8px', color: '#fff' }} />
          {/* The Legend component renders the legend */}
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </>
  );
};

export default PieMembers;
